import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AllProducts } from "./allProducts";
import { CatogeryProducts } from "./CatogeryProducts";
import { PeoductsSearch } from "./searchProducts";

const routes: Routes = [
  { path: "", component: AllProducts },
  { path: ":id", component: CatogeryProducts },
  { path: "search/:search_word", component: PeoductsSearch }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopRoutingModule {}
